<template>
<div class="header-page">
      <div class="header-swiper">
      <div class="header-navbar-logo" v-if="isSmallScreen===false" @click="toplogo">
        <img src="@/assets/2023logoImage/top-logo.png" alt="">
      </div>
      <div class="header-navbar-logo" v-else @click="toplogo">
        <img src="@/assets/2023logoImage/logo-t.png" alt="">
      </div>
      <!-- pc端 -->
      <div class="header-navbar-size" v-if="isSmallScreen===false">
        <span class="header-navbar-size-shouye1" @click="shouye">首页</span>
        <span class="header-navbar-size-shouye2"  v-if="isSmallScreen===false" @mouseover='onMouseover' >
          产品
        </span>
        <span class="header-navbar-size-shouye2" v-else  @click='lookSmall' >
          产品
        </span>
          <img class="xiajiantou" src="../assets/2023logoImage/xxjt.png" alt="">
        <span class="header-navbar-size-shouye3" @click="Contact">联系我们</span>
      </div>
      <!-- 移动端 -->
      <div class="header-navbar-er" v-else >
        <!-- <img class="ys" @click="Contact" src="../assets/2023logoImage/ys.png" alt=""> -->
        <div class="header-yuyues" @click="Contact">
          <p class="header-yanshis">预约演示</p>
        </div>
        <img class="hb" @click="naviga" src="../assets/iconfont/hbtb1.png" alt="">
      </div>
      <div class="header-tuoyuan" v-if="isSmallScreen===false">
        <img class="header-iphone" src="./../assets/2023logoImage/iphone-loukong.png" alt="">
        <p class="header-shoujihao">+86 400-638-5060</p>
      </div>
      <div class="header-yuyue" v-if="isSmallScreen===false" @click="Contact">
        <p class="header-yanshi">预约演示</p>
      </div>
      <div class="header-navbar-dis" @mouseout="onMouseEnter" @mouseover='onMouseover'>
        <ul>
          <li @click="kong">碳立方-企业零碳大脑-控排行业版</li>
          <li @click="zuji">碳立方-企业零碳大脑-碳足迹版</li>
          <li @click="danao">碳立方-城市零碳大脑</li>
          <li @click="yuanqu">碳立方-园区零碳大脑</li>
          <li @click="dian">碳立方-绿色减碳-新能源电站</li>
          <li @click="linye">碳立方-绿色减碳-林业碳汇</li>
          <li @click="youshi">碳立方-碳立方的优势</li>
        </ul>
      </div>
      <div class="header-navbar"></div>
      <img :src="require('@/assets/image/'+formattedSrc)" alt="">
      <el-dialog
        title="产品"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
          <ul class="tan">
          <li @click="kong">碳立方-企业零碳大脑-控排行业版</li>
          <li @click="zuji">碳立方-企业零碳大脑-碳足迹版</li>
          <li @click="danao">碳立方-城市零碳大脑</li>
          <li @click="yuanqu">碳立方-园区零碳大脑</li>
          <li @click="dian">碳立方-绿色减碳-新能源电站</li>
          <li @click="linye">碳立方-绿色减碳-林业碳汇</li>
          <li @click="youshi">碳立方-碳立方的优势</li>
        </ul>
      </el-dialog>
      <el-drawer
          ref="myDrawer"
          title=""
          size="80%"
          :visible.sync="drawer"
          :direction="direction"
          :before-close="handlenavbar">
            <div class="drawers-lo">
              <div class="ssy1"></div><span class="shouye" @click="shouye">首页</span>
               <span class="chanpin"  @click='lookSmall' >
                产品
                </span>
                <!-- 隐藏 -->
              <div class="ssy2"></div><span class="jia" v-if="flex % 2 !== 0">
                  +
                </span>
                <!-- 显示 -->
               <div class="ssy3"></div> <span class="jian" v-if="flex % 2 === 0">
                  -
                </span>
                <ul class="tan">
                 <span class="span1">></span> <li class="li1" @click="kong">碳立方-企业零碳大脑-控排行业版</li>
                 <span class="span2">></span> <li class="li2" @click="zuji">碳立方-企业零碳大脑-碳足迹版</li>
                 <span class="span3">></span> <li class="li3" @click="danao">碳立方-城市零碳大脑</li>
                 <span class="span4">></span> <li class="li4" @click="yuanqu">碳立方-园区零碳大脑</li>
                 <span class="span5">></span> <li class="li5" @click="dian">碳立方-绿色减碳-新能源电站</li>
                 <span class="span6">></span> <li class="li6" @click="linye">碳立方-绿色减碳-林业碳汇</li>
                 <span class="span7">></span> <li class="li7" @click="youshi"> 碳立方-碳立方的优势</li>
                  </ul>
              <div class="ssy3"></div> <span class="lianxi" @click="Contact">联系我们</span>
            </div>
      </el-drawer>
    </div>
</div>
</template>
<script>
export default {
  name: 'headers',
  data () {
    return {
      flex: 1,
      formattedSrc: '',
      drawer: false,
      direction: 'ltr',
      isSmallScreen: false,
      dialogVisible: false
      // currentRoute: ''
    }
  },
  props: ['imageSrc'],
  created () {
    this.formattedSrc = this.imageSrc.slice(16)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
    }
  },
  mounted () {
    // this.currentRoute = this.$route.path
    this.formattedSrc = this.imageSrc.slice(16)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
    }
  },
  methods: {
    jian () {
      this.flex = this.flex + 2
      var res = document.querySelectorAll('.tan li')
      res.forEach((item) => {
        item.style.display = 'none'
      })
    },
    toplogo () {
      this.$router.push('/')
    },
    // 打开弹框
    naviga () {
      this.drawer = true
    },
    handlenavbar (done) {
      done()
    },
    lookSmall () {
      var str1 = document.querySelector('.span1')
      var str2 = document.querySelector('.span2')
      var str3 = document.querySelector('.span3')
      var str4 = document.querySelector('.span4')
      var str5 = document.querySelector('.span5')
      var str6 = document.querySelector('.span6')
      var str7 = document.querySelector('.span7')
      var res1 = document.querySelector('.chanpin')
      var res = document.querySelectorAll('.tan li')
      var elements = document.querySelectorAll('.ssy3')
      var res2 = document.querySelector('.ssy2')
      if (this.flex % 2 !== 0) {
        res1.style.color = '#6dc5c6'
        str1.style.display = 'block'
        str2.style.display = 'block'
        str3.style.display = 'block'
        str4.style.display = 'block'
        str5.style.display = 'block'
        str6.style.display = 'block'
        str7.style.display = 'block'
        res2.style.backgroundColor = '#6dc5c6'
      } else {
        res1.style.color = '#fff'
        str1.style.display = 'none'
        str2.style.display = 'none'
        str3.style.display = 'none'
        str4.style.display = 'none'
        str5.style.display = 'none'
        str6.style.display = 'none'
        str7.style.display = 'none'
        res2.style.backgroundColor = '#313234'
      }
      this.flex++
      res.forEach((item) => {
        item.style.display = this.flex % 2 !== 0 ? 'none' : 'block'
      })
      const topValue = (this.flex % 2 !== 0) ? '214px' : '606px'
      elements.forEach((item) => {
        item.style.top = topValue
      })
    },
    // 鼠标移出
    onMouseEnter () {
      var res = document.querySelector('.header-navbar-dis')
      res.style.display = 'none'
    },
    // 鼠标移入
    onMouseover () {
      var res = document.querySelector('.header-navbar-dis')
      res.style.display = 'block'
    },
    // 首页
    shouye () {
      this.$router.push('/')
    },
    // 空排行业版
    kong () {
      this.$router.push('/product/industryEdition')
    },
    // 碳足迹版本
    zuji () {
      this.$router.push('/product/footprint')
    },
    // 城市零碳大脑
    danao () {
      this.$router.push('/product/brain')
    },
    // 园区零碳大脑
    yuanqu () {
      this.$router.push('/product/park')
    },
    // 新能源电站
    dian () {
      this.$router.push('/product/powerStation')
    },
    // 林业碳汇
    linye () {
      this.$router.push('/product/forestry')
    },
    // 碳立方的优势
    youshi () {
      this.$router.push('/product/advantage')
    },
    // 联系我们
    Contact () {
      this.$router.push('/product/Contact')
    },
    // 关闭弹窗
    handleClose (done) {
      done()
    }
  }

}
</script>

<style scoped lang="scss">
    .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  z-index: 899;
}
.header-navbar-logo{
  cursor: pointer;
  width: 200px;
  height: 60px;
  position: absolute;
  left: 18%;
  top: 16px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  height: 950px;
}
.header-tuoyuan{
  width: 188px;
  height: 40px;
  border: 1px solid #7abca0;
  z-index: 999;
  position: absolute;
  right: 21%;
  top: 20px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-iphone{
    width: 30px;
    height: 30px;
  }
  .header-shoujihao{
    // margin-left:10px ;
    color: #7abca0;
    font-weight: 600;
  }
}
.header-yuyue{
  cursor: pointer;
  width: 100px;
  height: 40px;
  background-color: #7abca0;
  position: absolute;
  right: 12%;
  top: 20px;
  border: 1px solid #7abca0;
  border-radius: 50px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-yanshi{
    color: #fff;
  }
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
  // .ys{
  //   position: absolute;
  //   left: -43px;
  //   top: 50%;
  //   transform: translateY(-50%);
  // }
  .header-yuyues{
    width: 70px;
    height: 28px;
    background-color: #63c0a0;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: -93px;
    top: 50%;
    transform: translateY(-50%);
    border: 1px solid #63c0a0;
    border-radius: 50px;
    .header-yanshis{
      color: #fff;
    }
  }
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover,
.header-navbar-size-shouye2:hover,
.header-navbar-size-shouye3:hover {
border-bottom: 2px solid #69bdbd;
color: #7abea2;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  color: black;
  background-color: #fff;
  position: absolute;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    // background-color: #fff;
    // padding-left: 20px;
    color: #7abca0;
  }
  to {
    // background-color: #6dc6c6;
    // padding-left: 40px;
    color: #7abca0;
  }
}
}

.drawers-lo{
  display: flex;
  flex-direction: column;
  // color: #fff;
  color: #000;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}

@media screen and (max-width: 1440px) and (min-width:1000px) {
    .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  z-index: 899;
}
.header-navbar-logo{
  width: 200px;
  height: 60px;
  position: absolute;
  left: 18%;
  top: 16px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  height: 950px;
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
}
.header-navbar-size{
  position: absolute;
  right: 20%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover,
.header-navbar-size-shouye2:hover,
.header-navbar-size-shouye3:hover {
border-bottom: 2px solid #69bdbd;
// transition: border-bottom 0.3s ease-in-out;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  color: black;
  background-color: #fff;
  position: absolute;
  right: 250px;
  top: 90px;
  z-index: 905;
  border-radius: 10px;
  ul li{
      // float: left;
      // color: #fff !important;
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
      // z-index: 960;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    // background-color: #fff;
    // padding-left: 20px;
    color: #7abca0;
  }
  to {
    // background-color: #6dc6c6;
    // padding-left: 40px;
    color: #7abca0;
  }
}
}

.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
 .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
    .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 202px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top:195px;
    display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 248px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 298px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 346px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 396px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 446px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 496px;
    display: none;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}

}
@media screen and (max-width:1800px) and (min-width: 1601px) {
      .xiajiantou{
          position: absolute;
          left: 130px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
  z-index: 899;
}
.header-navbar-logo{
  cursor: pointer;
  width: 200px;
  height: 60px;
  position: absolute;
  left: 18%;
  top: 14px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  height: 950px;
}
.header-tuoyuan{
  width: 188px;
  height: 40px;
  border: 1px solid #7abca0;
  z-index: 999;
  position: absolute;
  right: 21%;
  top: 20px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-iphone{
    width: 30px;
    height: 30px;
  }
  .header-shoujihao{
    margin-left:10px ;
    color: #7abca0;
    font-weight: 600;
  }
}
.header-yuyue{
  cursor: pointer;
  width: 100px;
  height: 40px;
  background-color: #7abca0;
  position: absolute;
  right: 12%;
  top: 20px;
  border: 1px solid #7abca0;
  border-radius: 50px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .header-yanshi{
    color: #fff;
  }
}
.header-navbar-er{
  margin-top: 20px;
  font-size: 25px;
}
.header-navbar-size{
  position: absolute;
  left: 35%;
  top: 32px;
  color: black;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover,
.header-navbar-size-shouye2:hover,
.header-navbar-size-shouye3:hover {
border-bottom: 2px solid #69bdbd;
color: #7abea2;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  color: black;
  background-color: #fff;
  position: absolute;
  left: 40%;
  top: 90px;
  z-index: 905;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 30px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    // background-color: #fff;
    // padding-left: 20px;
    color: #7abca0;
  }
  to {
    // background-color: #6dc6c6;
    // padding-left: 40px;
    color: #7abca0;
  }
}
}

.drawers-lo{
  display: flex;
  flex-direction: column;
  // color: #fff;
  color: #000;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}
}
@media screen and (min-width: 1920px) {
  .xiajiantou{
          position: absolute;
          left: 138px;
          top: 3px;
          width: 15px;
          height: 15px;
          z-index: 999;
        }
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: #fff;
}
.header-navbar-logo{
  width: 250px;
  height: 60px;
  position: absolute;
  left: 368px;
  top: 10px;
  z-index: 991;
}

.header-swiper-img{
  width: 100%;
  height: 100%;
}
.header-navbar-size{
  position: absolute;
  right: 20%;
  top: 32px;
  color: black;
  font-size: 17px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-size-shouye2:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-size-shouye3:hover{
  border-bottom: 2px solid #69bdbd ;
  color: #7abca0;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  color: black;
  position: absolute;
  right: 350px;
  top: 90px;
  z-index: 100;
  border-radius:10px ;
  ul li{
      height: 50px;
      line-height: 50px;
      padding-left: 40px;
       cursor: pointer !important;
  }
ul li:hover {
  /* 其他样式 */
  animation: hover-effect 0.3s forwards;
}

@keyframes hover-effect {
  from {
    color: #7abca0;
  }
  to {
    color: #7abca0;
  }
}
}
}
@media screen and (max-width: 375px) {
.header-navbar{
  width: 100%;
  height: 58px;
  // background-color: rgb(23, 21, 21);
  background-color: #262626;
  // opacity: 0.5;
  position: relative;
  left: 0;
  top: 0;
  // z-index: 999;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  // font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
// .tan{
//   width: 90%;
//   height: 400px;
//  li{
//   margin-bottom: -5px;
//  }
// }
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    // top: 50%;
    // transform: translate(-50%);
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    // top: 50%;
    // transform: translate(-50%);
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  // .ssy3{
  //   width: 10px;
  //   height: 10px;
  //   border-radius: 50%;
  //   background-color: #313234;
  //   border-style: solid;
  //   border-width: 1px;
  //   border-color: white;
  //   position: absolute;
  //   left: 24px;
  //   top: 201px;
  // }
  // .active{
  //   width: 10px;
  //   height: 10px;
  //   border-radius: 50%;
  //   background-color: #6dc5c6;
  //   border-style: solid;
  //   border-width: 1px;
  //   border-color: #6dc5c6;
  //   position: absolute;
  //   left: 24px;
  //   top: 201px;
  // }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 196px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 250px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 305px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 360px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 415px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 471px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 526px;
    display: none;
  }
}
}
@media screen and (max-width: 414px) and (min-width:391px) {
.header-navbar{
  width: 100%;
  height: 58px;
  // background-color: rgb(23, 21, 21);
  background-color: #262626;
  // opacity: 0.5;
  position: relative;
  left: 0;
  top: 0;
  // z-index: 999;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 101px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 154px;
  }
  // .ssy3{
  //   width: 10px;
  //   height: 10px;
  //   border-radius: 50%;
  //   background-color: #313234;
  //   border-style: solid;
  //   border-width: 1px;
  //   border-color: white;
  //   position: absolute;
  //   left: 24px;
  //   top: 206px;
  // }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 196px;
    top: 203px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 250px;
    top: 258px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 305px;
    top: 310px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 360px;
    top: 365px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 415px;
    top: 420px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 471px;
    top: 476px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    // top: 526px;
    top: 531px;
    display: none;
  }
}
}
@media screen and (max-width: 767px) and (min-width:415px) {
.header-navbar{
  width: 100%;
  height: 58px;
  // background-color: rgb(23, 21, 21);
  background-color: #262626;
  // background-color: #fff;
  // opacity: 0.5;
  position: relative;
  left: 0;
  top: 0;
  // z-index: 999;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 201px;
  }
  // .active{
  //   width: 10px;
  //   height: 10px;
  //   border-radius: 50%;
  //   background-color: #6dc5c6;
  //   border-style: solid;
  //   border-width: 1px;
  //   border-color: #6dc5c6;
  //   position: absolute;
  //   left: 24px;
  //   top: 201px;
  // }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 196px;
        display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 250px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 305px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 360px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 415px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 471px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 526px;
    display: none;
  }
}
}
@media screen and (max-width: 1000px) and (min-width:768px) {
  .header-navbar{
  width: 100%;
  height: 90px;
  background-color: rgb(23, 21, 21);
  //  background-color: rgba(0,0,0,0.4);
  // background-color: #fff;
  // opacity: 0.5;
  // position: absolute;
  // left: 0;
  // top: 0;
  z-index: 899;
}
.header-navbar-logo{
  width: 200px;
  height: 60px;
  position: absolute;
  // left: 253px;
  left: 4%;
  top: 20px;
  z-index: 998;
}

.header-swiper-img{
  width: 100%;
  // height: 100%;
  height: 950px;
}
.header-navbar-er{
  position: absolute;
  top: 5px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 35px;
    height: 35px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 20%;
  top: 32px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  text-shadow: gainsboro;
  margin-left: 30px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  margin-left: 50px ;
  padding-bottom: 37px;
  cursor: pointer !important;
}
.header-navbar-size-icon{
  z-index: 99;
  position: absolute;
  right: 86px;
  top: 0px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}
.header-navbar-size-shouye1:hover{
  border-bottom: 1px solid #fff ;
}
.header-navbar-size-shouye2:hover{
  border-bottom: 1px solid #fff ;
}
.header-navbar-size-shouye3:hover{
  border-bottom: 1px solid #fff ;
}
.header-navbar-dis{
  display: none;
  width: 300px;
  height: 350px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  // color: white;
  position: absolute;
  right: 250px;
  top: 90px;
  z-index: 905;
  border-top: 2px solid #69bdbd ;
}
// .header-navbar-dis li:hover{
//   z-index: 929;
//   background-color: #73c8c5;
//   color: #fff;
//   padding-left:60px ;
// }
// li{
//   color: #fff;
//   height: 50px;
//   line-height: 50px;
//   padding-left: 40px;
//   z-index: 960;
// }
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
 .jia{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 139px;
    font-size: 25px;
    color: #545960;
  }
    .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 96px;
  }
   .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 149px;
  }
  // .ssy3{
  //   width: 10px;
  //   height: 10px;
  //   border-radius: 50%;
  //   background-color: #313234;
  //   border-style: solid;
  //   border-width: 1px;
  //   border-color: white;
  //   position: absolute;
  //   left: 24px;
  //   top: 202px;
  // }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top:196px;
    display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 250px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 305px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 360px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 415px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 471px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 526px;
    display: none;
  }
}
  ::v-deep{
  .el-drawer{
      background-color: #1a1b1d !important;
    }
}

}
@media screen and (max-width: 390px) and (min-width:376px) {
        .swiperss{
            width: 100px;
            height: 5px;
            background-color: #b3c677;
            position: absolute;
            left: 18px;
            top: 256px;
            z-index: 1999;
        }
        .swipersst{
            width: 20px;
            height: 5px;
            background-color: #fff;
            position: absolute;
            left: 18px;
            top: 256px;
            z-index: 1999;
        }
        // .imagess{
        //   width: 100%;
        //   height: 200px;
        // }
.header-navbar{
  width: 100%;
  height: 58px;
  // background-color: rgb(23, 21, 21);
  background-color: #262626;
  // background-color: #fff;
  // opacity: 0.5;
  position: relative;
  left: 0;
  top: 0;
  // z-index: 999;
}
.header-navbar-logo{
  width: 107px;
  height: 50px;
  position: absolute;
  left: 13px;
  top: 16px;
  z-index: 999;
}

.header-swiper-img{
  width: 100%;
  height: 538px;
}
.header-navbar-er{
  position: absolute;
  top: -2px;
  left: 90%;
  font-size: 28px;
  color: #fff;
  z-index: 988;
  .hb{
    width: 25px;
    height: 25px;
  }
}
.header-navbar-size{
  position: absolute;
  right: 15%;
  top: 27px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  z-index: 999;
}
.header-navbar-size-shouye1{
  position: absolute;
  top: -20px;
  left: -126px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye2{
  position: absolute;
  top: -20px;
  left: -93px;
  margin-left: 10px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-size-shouye3{
  position: absolute;
  top: -20px;
  left: -79px;
  margin-left: 30px ;
  padding-bottom: 25px;
  cursor: pointer !important;
}
.header-navbar-dis{
  display: none;
  width: 100%;
  height: 150px;
  // background-color: rgb(23, 21, 21);
  // opacity: 0.5;
  background-color: #fff;
  color: white;
  position: absolute;
  /* right: 150px; */
  top: 90px;
  left: 50%;
  transform: translate(-50%);
  z-index: 100;
  border-top: 2px solid #69bdbd ;
}
::v-deep{
.el-drawer{
    background-color: #1a1b1d !important;
  }
}
.drawers-lo{
  display: flex;
  flex-direction: column;
  color: #fff;
  .shouye{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .chanpin{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    // border-top: 1px solid #73c8c5;
    // border-bottom: 1px solid #73c8c5 ;
  }
  .lianxi{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
  }
  .tan li{
    padding-bottom: 15px;
    padding-left: 55px ;
    padding-top: 15px ;
    line-height: 23px;
    border-top: 1px solid #313234;
    border-bottom: 1px solid #313234 ;
    display: none;
  }
  .jia{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .jian{
    position: absolute;
    right: 20px;
    top: 144px;
    font-size: 25px;
    color: #545960;
  }
  .ssy1{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 103px;
  }
  .ssy2{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 158px;
  }
  .ssy3{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #313234;
    border-style: solid;
    border-width: 1px;
    border-color: white;
    position: absolute;
    left: 24px;
    top: 214px;
  }
  .tan .span1{
    color: #fff;
    position: absolute;
    left: 25px;
    top:208px;
    display: none;
  }
   .tan .span2{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 265px;
        display: none;
  }
   .tan .span3{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 321px;
        display: none;
  }
  .tan .span4{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 376px;
        display: none;
  }
  .tan .span5{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 432px;
        display: none;
  }
  .tan .span6{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 488px;
    display: none;
  }
  .tan .span7{
    color: #fff;
    position: absolute;
    left: 25px;
    top: 544px;
    display: none;
  }
}
}
</style>
